'use client';

import { type StateAbbreviation } from '@repo/supergraph/marketplace/types';
import { type PropsWithChildren, useEffect, useState } from 'react';
import { getSafeRegionCodeFromClientCookies } from '../utils/getSafeRegionCode';
import { GeoContext } from './context';

type GeoProviderProps = {
  initialLocation?: StateAbbreviation;
};

export function GeoProvider({ children, initialLocation }: PropsWithChildren<GeoProviderProps>) {
  const [isReady, setIsReady] = useState(false);
  const [regionCode, setRegionCode] = useState<StateAbbreviation | undefined>(initialLocation);
  const [initialRegionCode, setInitialRegionCode] = useState<StateAbbreviation | undefined>(
    initialLocation,
  );

  useEffect(() => {
    const clientRegionCode = getSafeRegionCodeFromClientCookies();
    if (clientRegionCode) {
      setRegionCode(clientRegionCode);
      setInitialRegionCode(clientRegionCode);
    }
    setIsReady(true);
  }, []);

  return (
    <GeoContext.Provider value={{ isReady, regionCode, setRegionCode, initialRegionCode }}>
      {children}
    </GeoContext.Provider>
  );
}
